import React, { Component } from "react";
import "./intro.css";
import GetStarted from "../assets/button/get-started.png";

class Intro extends Component {
  state = {};
  render() {
    return (
      <div className="container intro">
        <div className="row">
          <div className="col-8 alignment">
            <h1 className="The-best-place-to-ex">
              The best place to exchange digital currencies
            </h1>
          </div>
        </div>
        <div className="row">
          <div className="col-8 alignment">
            <p className="More-trading-pairs">
              More trading pairs. Better access. Greater trust. Trusted by over
              1,300,000 people across 200 countries
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <a href="/crypto/signup">
              <img src={GetStarted} alt="" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;
